import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginFailure, selectSubMenu, fetchOrdersFailure, fetchMachinesFailure, setAccessPermissions } from '../../actions/index';
import './SideBarMenu.css';

const SideBarMenu = () => {
  const [openSection, setOpenSection] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.access.permissions);
  const Navigate = useNavigate();

  useEffect(() => {
    Navigate('/');
  }, [permissions])
  

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? '' : section);
    if (section === 'mantenimiento') {
      Navigate('/mantenimiento');
    } else if (section === 'inventario') {
      Navigate('/inventario');
    } else if (section === 'produccion') {
      Navigate('/produccion');
    } else if (section === 'calidad') {
      Navigate('/calidad');
    } else {
      Navigate('/');
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleSubMenu = (submenu) => {
    setIsMenuOpen(!isMenuOpen);
    dispatch(selectSubMenu(submenu)); // Despacha la acción para seleccionar el submenú
  };

  const handleLogout = () => {
    dispatch(loginFailure('User logged out'));
    dispatch(fetchOrdersFailure(''));
    dispatch(fetchMachinesFailure(''));
    dispatch(setAccessPermissions(''));
    sessionStorage.removeItem('user');
    
  };

  return (
    <div>
      <button className={`hamburger-button ${isMenuOpen ? 'menu-open' : 'menu-closed'}`} onClick={toggleMenu}>
        {isMenuOpen ? '×' : '☰'}
      </button>
      <div className={`sidebar-menu ${isMenuOpen ? 'open' : ''}`}>
        {permissions.includes('viewMantenimiento') && (
          <div className="menu-section">
            <div className="menu-title" onClick={() => toggleSection('mantenimiento')}>
              <div>Mantenimiento</div>
              <div>{openSection === 'mantenimiento' ? '▲' : '▼'}</div>
            </div>
            {openSection === 'mantenimiento' && (
              <div className="submenu">
                <div className="submenu-item" onClick={() => toggleSubMenu('maquinas')}>Máquinas y herramientas</div>
                <div className="submenu-item" onClick={() => toggleSubMenu('ordenes')}>Órdenes de mantenimiento</div>
                <div className="submenu-item" onClick={() => toggleSubMenu('historialMantenimiento')}>Historial de mantenimiento</div>
              </div>
            )}
          </div>
        )}
        {permissions.includes('viewInventario') && (
          <div className="menu-section">
            <div className="menu-title" onClick={() => toggleSection('inventario')}>
              <div>Inventario</div>
              <div>{openSection === 'inventario' ? '▲' : '▼'}</div>
            </div>
            {openSection === 'inventario' && (
              <div className="submenu">
                <div className="submenu-item" onClick={() => toggleSubMenu('artículos')}>Artículos</div>
                <div className="submenu-item" onClick={() => toggleSubMenu('entrada/salidas')}>Entradas y salidas</div>
              </div>
            )}
          </div>
        )}
        {permissions.includes('viewProduccion') && (
          <div className="menu-section">
            <div className="menu-title" onClick={() => toggleSection('produccion')}>
              <div>Producción</div>
              <div>{openSection === 'produccion' ? '▲' : '▼'}</div>
            </div>
            {openSection === 'produccion' && (
              <div className="submenu">
                <div className="submenu-item" onClick={() => toggleSubMenu('lineas')}>Líneas de producción</div>
                <div className="submenu-item" onClick={() => toggleSubMenu('ordenes')}>Órdenes de producción</div>
              </div>
            )}
          </div>
        )}
        {permissions.includes('viewCalidad') && (
          <div className="menu-section">
            <div className="menu-title" onClick={() => toggleSection('calidad')}>
              <div>Calidad</div>
              <div>{openSection === 'calidad' ? '▲' : '▼'}</div>
            </div>
            {openSection === 'calidad' && (
              <div className="submenu">
                <div className="submenu-item" onClick={() => toggleSubMenu('controles')}>Controles de calidad</div>
                <div className="submenu-item" onClick={() => toggleSubMenu('reportes')}>Reportes</div>
              </div>
            )}
          </div>
        )}
        <div className="menu-section">
          <div className="menu-title" onClick={handleLogout}>
            <div>Cerrar sesión</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBarMenu;
